import PropTypes from "prop-types";
import { Subtitle } from "components/atoms/Text";

const StepCard = ({ icons, title, description }, props) => {
    return (
        <div className="w-full relative phone:h-[409px] tablet:h-[394px] z-50 p-8 phone:p-6 tablet:p-6 pb-8 rounded-lg bg-neutral-10">
            <div className="w-full flex overflow-hidden desktop:h-[210px] phone:h-[185px] phone:max-w-[278px] phone:mx-auto items-end justify-center p-[14px] bg-primary-surface mx-auto rounded-lg mb-6">
                <img className="relative top-[24px] phone:top-[32px]" src={`/images/affiliates/howitworks/${icons}`} {...props} alt={icons.replace([".svg", ".png"], "")} />
            </div>
            <h1 className="font-semibold text-left text-heading-4 tablet:text-heading-5 phone:text-heading-5 text-neutral-100">{title}</h1>
            <Subtitle classNames="mt-3 tablet:!text-[16px] tablet:!leading-[27.2px] phone:!text-[16px] break-normal tablet:mt-2 phone:mt-2 text-left">{description}</Subtitle>
        </div >
    );
};

StepCard.propTypes = {
    icons: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
};

export default StepCard;